import { defineComponent as _defineComponent } from 'vue'
import { translate } from '@/util/commonFun'
import { computed, withDefaults } from 'vue'

interface PropsType {
  show?: boolean
  isNewContent?: boolean
  width?: string
  height?: string
  content?: string
  styleObj?: object
}


export default /*#__PURE__*/_defineComponent({
  __name: 'newContent',
  props: {
    show: { type: Boolean, default: true },
    isNewContent: { type: Boolean, default: true },
    width: null,
    height: null,
    content: { default: '' },
    styleObj: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { show: boolean, isNewContent: boolean, width?: string, height?: string, content: string, styleObj: object }



const styleObj = computed(() => ({
  width: props.width,
  height: props.height,
  ...props.styleObj,
}))

const content = computed(() => props.content || translate('common.new'))

return { __sfc: true,props, styleObj, content }
}

})